export function wrapUnknownToError(errorToWrap: unknown): Error {
  if (errorToWrap instanceof Error) {
    return errorToWrap;
  }

  if (errorToWrap instanceof Object && 'message' in errorToWrap && typeof errorToWrap.message === 'string') {
    return new Error(errorToWrap.message);
  }

  return new Error(String(errorToWrap));
}
